import {Drawer} from "@mui/material";
import {destroyModal} from "../../utils/modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const WiFiModal = () => {
    const {menuInfo} = useSelector(state => state.app)
    const {t} = useTranslation();

    return (
        <>
            {
                <Drawer
                    PaperProps={{
                        sx: {
                            backgroundColor: "transparent",
                            boxShadow: 'none'
                        }
                    }}
                    anchor={'bottom'}
                    open={true}
                    onClose={destroyModal}
                >

                    <div className={'w-full max-w-[420px] mx-auto bg-[#fff] h-[40%] rounded-t-[30px] p-4 relative'}>
                        <FontAwesomeIcon icon={faCircleXmark} size={'2x'} className={'text-black w-[40px] h-[40px] absolute'} style={{ right: 5, top: 5 }} onClick={destroyModal}/>

                        <div className={'overflow-scroll no-scrollbar h-[200px] flex flex-col justify-start items-center py-6 mt-6'}>
                            <div className={'flex flex-col justify-center items-center'}>
                                <span className={'text-[#555555] text-[20px] font-bold text-center mb-2'}>{t('menu.wifi')}</span>
                                <div className={'w-full flex flex-row items-center justify-between my-1'}>
                                    <div className={'w-full image-bg-thirdy text-[#555] m-2 py-2 px-3 rounded-xl font-bold'}>
                                        <span> {t('general.ssid')}: </span>
                                        <span className={'font-normal'}>{menuInfo?.wifi?.ssid || '-'}</span>
                                    </div>
                                </div>

                                <div className={'w-full flex flex-row items-center justify-between my-1'}>
                                    <div className={'w-full image-bg-thirdy text-[#555] m-2 py-2 px-3 rounded-xl font-bold'}>
                                        <span> {t('general.password')}: </span>
                                        <span className={'font-normal'}>{menuInfo?.wifi?.password || '-'}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </Drawer>
            }
        </>
    )
}

export default WiFiModal;